// extracted by mini-css-extract-plugin
module.exports = {"BntSecondary":"FeatureSwitch_BntSecondary___lUIm","BtnPrimary":"FeatureSwitch_BtnPrimary__zYsT3"};